import { createRouter } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen';
import { queryClient } from '@/lib/query-client';

// SPA servida na raiz (/). server.js faz SPA fallback nas rotas que não
// são /api, /auth, /login, /files, /legacy, /styles ou estáticos top-level.
// /v2/* segue funcionando como alias para retrocompatibilidade.
export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
